import React from 'react';
import './App.css';
import AuthContextProvider from './contexts/AuthContext';
import AplicationRoutes from './routes/Index.routes';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from "@vercel/speed-insights/react"

function App() {
	return (
		<AuthContextProvider>
			<AplicationRoutes />
			<Analytics />
      <SpeedInsights />
		</AuthContextProvider>
	);
}
export default App;
